import { requester } from '../utils';

export const getPrinters = (query) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/printer?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
        console.log(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getPrinterById = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/printer/${id}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
        console.log(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const updatePrinter = printerObject => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/printer`,
        method: 'PUT',
        data: printerObject
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const updatePrinterIsActive = (id, isActive) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/printer/active`,
        method: 'PUT',
        data: {
          id,
          isActive
        }
      })
      .then(result => {
        resolve(result.status);
      })
      .catch(err => {
        reject(err);
      });
  });
}